"use client";

import { useQueryClient } from "@tanstack/react-query";

export function QueryClientLoader({
  configFlags,
  orgId,
}: {
  configFlags: Record<string, boolean> | undefined;
  orgId: number;
}) {
  const queryClient = useQueryClient();
  queryClient.setQueryData(["configFlags", orgId], configFlags);

  return <></>;
}
